import { createContext, useContext, useEffect, useState } from 'react';
import { onAuthStateChanged, getAuth } from 'firebase/auth';
import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';

const firebaseConfig = {

    apiKey: "AIzaSyBWUI--ySy38v4lgXSflAs38h4JgnXYepc",
  
    authDomain: "rocketprepai.firebaseapp.com",
  
    projectId: "rocketprepai",
  
    storageBucket: "rocketprepai.firebasestorage.app",
  
    messagingSenderId: "399338419505",
  
    appId: "1:399338419505:web:5342246715e98e1ae96c10",
  
    measurementId: "G-W7YTHQ9X8S"
  
  };
  
  
  // Initialize Firebase
  
  const app = initializeApp(firebaseConfig);
  
  const auth = getAuth(app);
  
  const analytics = getAnalytics(app);

  const AuthContext = createContext();

  
  export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
  
    useEffect(() => {
      const unsubscribe = onAuthStateChanged(auth, currentUser => {
        setUser(currentUser);
        setLoading(false);
      });
  
      return () => unsubscribe();
    }, []);
  
    return (
      <AuthContext.Provider value={{ user, loading }}>
        {children}
      </AuthContext.Provider>
    );
  }
  
  export function useAuth() {
    return useContext(AuthContext);
  }